export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGOUT = "LOGOUT"
export const LOAD_PROFILE = "LOAD_PROFILE"

export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS"
export const HOME_VIDEOS_FAIL = "HOME_VIDEOS_FAIL"
export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST"

export const RELATED_VIDEO_REQUEST = "RELATED_VIDEO_REQUEST"
export const RELATED_VIDEO_SUCCESS = "RELATED_VIDEO_SUCCESS" 
export const RELATED_VIDEO_FAIL = "RELATED_VIDEO_FAIL"
